import { cn } from "@/engine/support/classNames";

import { AnimalHead } from "./AnimalHead";
import type { AnimalId } from "./campData";
import type { CampTone } from "./campTones";

export interface CampAvatarProps {
  /** Which animal identifies this person. */
  beast: AnimalId;
  /** Identity tone of the disc. */
  tone?: CampTone | undefined;
  /** Disc diameter in pixels. */
  size?: number | undefined;
  /** Speaking draws the ember ring and lights the animal. */
  speaking?: boolean | undefined;
  /** Marks the disc as you, with the pale ember ring. */
  isYou?: boolean | undefined;
  /** Silent or muted people are dimmed. */
  dimmed?: boolean | undefined;
  className?: string | undefined;
}

/** A tone is membership, so it is drawn in its own token, never a person's colour. */
const TINT_BY_TONE: Record<CampTone, string> = {
  ember: "hsl(var(--primary))",
  you: "hsl(var(--you))",
  "team-1": "hsl(var(--team-1))",
  "team-2": "hsl(var(--team-2))",
  muted: "hsl(var(--identity-ash))",
};

/** A round disc carrying a person's animal — the camp's identity atom. */
export function CampAvatar({
  beast,
  tone = "ember",
  size = 38,
  speaking = false,
  isYou = false,
  dimmed = false,
  className,
}: CampAvatarProps) {
  return (
    <AnimalHead
      animal={beast}
      tint={TINT_BY_TONE[tone]}
      size={size}
      speaking={speaking}
      dim={dimmed}
      you={isYou}
      data-speaking={speaking || undefined}
      className={cn(className)}
    />
  );
}
